type GraphQLErrorLike = { message?: unknown };

export function propertyErrorMessage(error: unknown, fallback: string) {
  const graphQLErrors = (error as { graphQLErrors?: GraphQLErrorLike[] } | null)
    ?.graphQLErrors;
  if (Array.isArray(graphQLErrors)) {
    const uniqueMessages = Array.from(
      new Set(
        graphQLErrors
          .map((item) =>
            typeof item.message === 'string' ? item.message.trim() : '',
          )
          .filter(Boolean),
      ),
    );
    if (uniqueMessages.length) return uniqueMessages.join(' · ');
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message.trim();
  }
  return fallback;
}
